export const squaresSlider = (instance, options) => {
    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 15,
        cssMode: true,
        breakpoints: {
            1024: {
                cssMode: false,
                spaceBetween: 12,
                slidesPerView: 6,
                slidesPerGroup: 6
            }
        },
    }
}